import {
  AddCorpDomainRequest,
  AddCorpDomainResponse,
  DeleteCorpDomainRequest,
  DeleteCorpDomainResponse,
  ListCorpDomainsRequest,
  ListCorpDomainsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/identity/v1/org_domain_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "../types";

export type ListCorpDomainsParams = {
  domainFilter?: string;
  pageSize?: number;
  pageToken?: string;
};

export const listCorpDomains = async (
  params: ListCorpDomainsParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListCorpDomainsResponse> => {
  const req = new ListCorpDomainsRequest({
    domainFilter: params.domainFilter ?? "",
    pageSize: params.pageSize ?? 0,
    pageToken: params.pageToken ?? "",
  });
  return supportServiceConnectClient.listCorpDomains(req, { headers });
};

export const addCorpDomain = async (
  domain: string,
  headers: Record<RequestMetadata, string>,
): Promise<AddCorpDomainResponse> => {
  const req = new AddCorpDomainRequest({ domain });
  return supportServiceConnectClient.addCorpDomain(req, { headers });
};

export const deleteCorpDomain = async (
  domain: string,
  headers: Record<RequestMetadata, string>,
): Promise<DeleteCorpDomainResponse> => {
  const req = new DeleteCorpDomainRequest({ domain });
  return supportServiceConnectClient.deleteCorpDomain(req, { headers });
};
